import { apiFetch } from "./apiClient";

export const fetchWorkspaces = async () => apiFetch("/api/workspaces/list");

export const fetchWorkspaceDetails = async (workspaceId) =>
  apiFetch(
    `/api/workspaces/details?workspace_id=${encodeURIComponent(workspaceId)}`,
  );

export const createWorkspace = async (name) =>
  apiFetch("/api/workspaces/create", {
    method: "POST",
    body: { name },
  });

export const updateWorkspaceSettings = async (workspaceId, updates) =>
  apiFetch("/api/workspaces/settings", {
    method: "PUT",
    body: { workspace_id: workspaceId, ...updates },
  });

export const fetchWorkspaceApiKeys = async (workspaceId) =>
  apiFetch(
    `/api/workspaces/api-keys?workspace_id=${encodeURIComponent(workspaceId)}`,
  );

export const saveWorkspaceApiKeys = async (workspaceId, data, clear = []) =>
  apiFetch("/api/workspaces/api-keys", {
    method: "PUT",
    body: { workspace_id: workspaceId, data, clear },
  });

export const inviteWorkspaceMember = async (workspaceId, email, role) =>
  apiFetch("/api/workspaces/invites", {
    method: "POST",
    body: { workspace_id: workspaceId, email, role },
  });

export const revokeWorkspaceInvite = async (workspaceId, inviteId) =>
  apiFetch("/api/workspaces/invites", {
    method: "PATCH",
    body: { workspace_id: workspaceId, invite_id: inviteId, status: "revoked" },
  });

export const updateWorkspaceMember = async (workspaceId, memberId, updates) =>
  apiFetch("/api/workspaces/members", {
    method: "PATCH",
    body: { workspace_id: workspaceId, id: memberId, ...updates },
  });

export const removeWorkspaceMember = async (workspaceId, memberId) =>
  apiFetch(
    `/api/workspaces/members?workspace_id=${encodeURIComponent(
      workspaceId,
    )}&id=${encodeURIComponent(memberId)}`,
    { method: "DELETE" },
  );

export const exportWorkspaceData = async (workspaceId) =>
  apiFetch("/api/workspaces/delete", {
    method: "POST",
    body: { workspace_id: workspaceId, action: "export" },
  });

export const deleteWorkspace = async (workspaceId) =>
  apiFetch("/api/workspaces/delete", {
    method: "DELETE",
    body: { workspace_id: workspaceId },
  });

export const fetchPendingInvites = async () =>
  apiFetch("/api/workspaces/invites?status=pending");

export const acceptWorkspaceInvite = async (inviteId) =>
  apiFetch("/api/workspaces/accept-invite", {
    method: "POST",
    body: { invite_id: inviteId },
  });

export const rejectWorkspaceInvite = async (inviteId) =>
  apiFetch("/api/workspaces/invites", {
    method: "PATCH",
    body: { invite_id: inviteId, status: "rejected" },
  });
